export default __webpack_public_path__ + "static/media/organization.c96e38c2.webp";